import React, { useState } from "react";
import { BotaoMenor, Spinner } from "../../StyledComponent";
import CPFFound from "../CPFFound";
import Cognito from "../../../Amplify";
import Fade from "@material-ui/core/Fade";
import { RiArrowGoBackFill } from "react-icons/ri";
import "./styles.scss";
const MsgSendNewCode = ({ email }) => {
  const [goBack, setGoBack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userMsg, setUserMsg] = useState("");

  async function sendNewCode() {
    setLoading(true);
    await Cognito.resendCode(email);
    setLoading(false);
    setUserMsg("Código reenviado com sucesso");
  }

  return (
    <>
      {goBack ? (
        <CPFFound userEmail={email} />
      ) : (
        <Fade in>
          <div className="centralized-column msgSendNewCode">
            <h1>Código de verificação:</h1>
            <div className="msgSendNewCode__msg">
              <p>
                Antes de fazer o pedido de um novo código de verificação,{" "}
                <strong>
                  confira sua caixa de entrada, spam ou lixo eletrônico do
                  e-mail cadastrado.
                </strong>
              </p>
              <p>
                Caso não receba o código de verificação novamente,{" "}
                <b>favor entrar em contato com nosso suporte.</b>
              </p>
            </div>
            {userMsg}
            {loading ? (
              <Spinner />
            ) : (
              <BotaoMenor
                color="#ffffff"
                backgroundcolor="#003DA5"
                id="btnSendNewCode"
                onClick={(e) => {
                  e.preventDefault();
                  sendNewCode();
                }}
              >
                REENVIAR CÓDIGO
              </BotaoMenor>
            )}
            <div
              onClick={(e) => {
                e.preventDefault();
                setGoBack(true);
              }}
              className="msgSendNewCode__btnBack centralized"
              id="btnFoundMyCode"
            >
              <RiArrowGoBackFill />
              <span> Encontrei meu codigo</span>
            </div>
          </div>
        </Fade>
      )}
    </>
  );
};

export default MsgSendNewCode;
